import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const ShipmentModeGroup = Object.freeze({
    PHYSICAL: 'physical',
    E_TICKET: 'eTicket',
    TOURNAMENT_APP: 'tournamentApp',
    UNKNOWN: 'unknown',
} as const);

export type IShipmentModeGroup = ValuesType<typeof ShipmentModeGroup>;
